import Vue from 'vue';

Vue.component('outlet-central-settings-index', () =>
    import(/* webpackChunkName: 'outlet-central-settings-index' */ './outlet-central-settings-index'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/outlet-central-settings/index.js